import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Head, Card, Field, KV, Tag } from "../components/bits";
import { PrivacyControls } from "../components/PrivacyControls";

const RULES = ["At least 12 characters", "At least one letter and one number", "Not your email address", "Not a commonly used password"];

export default function Security() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success(data.message || "Password changed"); setF({ current_password: "", new_password: "", confirm: "" });
    } catch (ex) { toast.error(errText(ex)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="security-page">
      <Head title="Security & privacy" sub="Change your password, control what the AI coach may read, export everything you own, or delete your account." />
      <div className="grid g2">
        <Card title="Change password" testId="change-password-card">
          <form onSubmit={submit}>
            <Field label="Current password"><input type="password" value={f.current_password} onChange={set("current_password")} required autoComplete="current-password" data-testid="current-password-input" /></Field>
            <Field label="New password"><input type="password" value={f.new_password} onChange={set("new_password")} required minLength={12} autoComplete="new-password" data-testid="new-password-input" /></Field>
            <Field label="Confirm new password"><input type="password" value={f.confirm} onChange={set("confirm")} required minLength={12} autoComplete="new-password" data-testid="confirm-password-input" /></Field>
            <button className="btn" disabled={busy} data-testid="change-password-btn"><ShieldCheck size={14} /> {busy ? "…" : "Change password"}</button>
          </form>
        </Card>
        <Card title="Password rules" testId="password-rules-card">
          {RULES.map((r) => <KV key={r} k={r} v={<Tag kind="info">required</Tag>} />)}
          <div className="note mt-3">Signed in as <b>{user?.email}</b> · role <b>{user?.role}</b>. Changing your password signs out every other device.</div>
        </Card>
      </div>
      <h2 style={{ margin: "28px 0 12px" }} data-testid="privacy-heading">Privacy controls</h2>
      <div className="grid g2"><PrivacyControls /></div>
    </div>
  );
}
